// Legacy exception, not the preferred pattern: this wrapper exposes MUI button props
// and custom focus styling. Migrate that API before using the internal IconButton.
// nosemgrep: no-mui-icon-button
import { IconButton, IconButtonProps, useTheme } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { HelpCircleIcon, IconProps } from '@/components/icons/HelpCircleIcon';
import { COLORS } from '@/styles/tokens/colors';

export interface HelpIconButtonProps {
  buttonProps?: Partial<IconButtonProps>;
  iconProps?: Partial<IconProps>;
}

function HelpIconButtonInner(
  { buttonProps = {}, iconProps = {} }: HelpIconButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  // Determine the color based on theme mode
  const iconColor = isDark ? COLORS.NAVY[300] : COLORS.TEXT.PRIMARY;

  return (
    <IconButton
      aria-label="help"
      ref={ref}
      {...buttonProps}
      sx={{
        padding: 0,
        ml: 0.5,
        color: iconProps.color || iconColor,
        '&:focus-visible': {
          outline: `2px solid ${iconColor}`,
          outlineOffset: 2,
          borderRadius: '50%',
        },
        ...buttonProps.sx,
      }}
    >
      <HelpCircleIcon
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        size={16}
        color={iconProps.color || iconColor}
        {...iconProps}
      />
    </IconButton>
  );
}

export const HelpIconButton = forwardRef<
  HTMLButtonElement,
  HelpIconButtonProps
>(HelpIconButtonInner);
